'use strict';

var poParser = require('./lib/poparser');

module.exports = {
  po: {
    parse: poParser.parse,
    createParseStream: poParser.stream,
    compile: require('./lib/pocompiler')
  },

  mo: {
    parse: require('./lib/moparser'),
    compile: require('./lib/mocompiler')
  }
};



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/gettext-parser/index.js
// module id = ../../../../gettext-parser/index.js
// module chunks = vendor